import React from "react";

const PracticeQuestions = () => {
    return (
        <div className="ch-quiz-questions">
            <span>Practice Questions</span>
        </div>
    );
};

export default PracticeQuestions;